import { splitEvery } from "rambda";
import { Children, CSSProperties } from "react";
import myStyle from "../cim-sub-menu.module.css";

const styleForWidgetItemsContainer = {
  marginTop: "10px",
  display: "flex",
  flexDirection: "column",
  flex: 1,
  rowGap: "13px",
  paddingLeft: "13px",
  paddingRight: "4px",
  paddingBlock: "5px",
  paddingTop: "10px",
} as CSSProperties;

const splitListToPairs = splitEvery(2);

function setScrollableFadeEffect(element: HTMLElement) {
  const isScrollable = element.scrollHeight > element.clientHeight;
  // GUARD: If element is not scrollable, remove all classes
  if (!isScrollable) {
    element.classList.remove(myStyle["is-bottom-overflowing"], myStyle["is-top-overflowing"]);
    return;
  }

  // Otherwise, the element is overflowing!
  // Now we just need to find out which direction it is overflowing to (can be both).
  // One pixel is added to the height to account for non-integer heights.
  const isScrolledToBottom = element.scrollHeight < element.clientHeight + element.scrollTop + 1;
  const isScrolledToTop = isScrolledToBottom ? false : element.scrollTop === 0;
  element.classList.toggle(myStyle["is-bottom-overflowing"], !isScrolledToBottom);
  element.classList.toggle(myStyle["is-top-overflowing"], !isScrolledToTop);
}

function WidgetItemLine({ children }: { children: React.ReactNode }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-evenly",
        gap: "13px",
        padding: "1px",
      }}
    >
      {children}
    </div>
  );
}

export function ScrollWithFade({ children }: { children: React.ReactNode }) {
  return (
    <div
      ref={(element) => {
        if (element) {
          setScrollableFadeEffect(element);
        }
      }}
      onScroll={(e) => {
        const element = e.currentTarget;
        setScrollableFadeEffect(element);
      }}
      className={myStyle.scrollableContent}
      style={styleForWidgetItemsContainer}
    >
      {splitListToPairs(Children.toArray(children)).map((pair, index) => (
        <WidgetItemLine key={index}>{pair}</WidgetItemLine>
      ))}
    </div>
  );
}

export function useFadeInScrollview() {
  return {
    onScroll: (e: React.UIEvent) => {
      const element = e.currentTarget as HTMLElement;
      if (element) {
        setScrollableFadeEffect(element);
      }
    },
    className: myStyle.scrollableContent,
    onMount: (element: HTMLElement | null) => {
      if (element) {
        setScrollableFadeEffect(element);
      }
    },
  } as const;
}
